import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomSection, getDefaultSection } from 'frontend/redux/actions/custom-section-actions';
import { getSectionDefaultById } from 'frontend/api/services/endpointSection';

export const CustomSectionComp = ({ id, title }) => {
  const dispatch = useDispatch();
  const { raw } = useSelector((state) => state.sectionState);
  const [html, setHtml] = useState(undefined);
  const [htmlDefault, setHtmlDefault] = useState()

  const token = useSelector(
    (state) => state.applicationState.token
  );

  const getSection = async () => {
      try {
        const response = await getSectionDefaultById(id, token)
        setHtmlDefault(response.data)
      } catch (error) {
        console.error(error)
      }
  }

  useEffect(() => {
    if(title === 'Custom'){
      id && dispatch(getCustomSection(id))
    }else if(title === 'DefaultHtml'){
      id && dispatch(getDefaultSection(id))
    }else {
      getSection()
    }
  }, []);

  useEffect(() => {
    // if (raw && title !== 'Default') {
      setHtml(raw.tipoSeccion?.nombre !== 'URL');
    // }
  }, [raw]);

  if (!raw.contenido && !htmlDefault) {
    return null;
  }

  return (
    <div className='container pt-10 pb-10 w-screen'>
      {html ? (
        <div
          className='content'
          dangerouslySetInnerHTML={{ __html: raw.contenido }}
        />
      )
        : (
          <iframe
            title='External link'
            frameBorder='0'
            style={{ overflow: 'hidden', height: '50rem', width: '100%' }}
            height='100%'
            width='100%'
            src={raw.contenido ? raw.contenido : htmlDefault?.url}
          />
        )}
    </div>

  );
};
